import Settlement from './settlement.container'

export default Settlement
